import React, { forwardRef, useMemo, useRef } from 'react';
import PlusPairedWithText from '../../components/text-pairing/Plus';
import { AnimatePresence } from 'framer-motion';
import { createTransition, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import styled from '@emotion/styled';
import { useButtonMotion } from '@polestar/component-warehouse-react/components/button/internal/buttonMotion';
import { AnimatedIconInner, AnimatedIconWrapper, animatedRotationIconPairingWithTextContainerStyling, } from '../../Icons.helpers';
const AnimatedPlus = forwardRef(() => {
    const { hover } = useButtonMotion();
    const hoverCounter = useRef(0);
    useMemo(() => {
        if (hover) {
            hoverCounter.current++;
        }
    }, [hover]);
    return (React.createElement(AnimatedIconWrapper, { textPairing: true },
        React.createElement(AnimatePresence, null,
            React.createElement(AnimatedIconInner, { key: hoverCounter.current, initial: hoverCounter.current === 0
                    ? false
                    : {
                        opacity: 1,
                        transform: 'rotateZ(0deg)',
                    }, animate: {
                    opacity: 1,
                    transform: 'rotateZ(90deg)',
                }, transition: createTransition({
                    duration: 0.6,
                    ease: MotionEasings.default,
                }) },
                React.createElement(StyledPlusPairedWithText, null)))));
});
AnimatedPlus.displayName = 'AnimatedPlus';
export default AnimatedPlus;
const StyledPlusPairedWithText = styled(PlusPairedWithText) `
  ${animatedRotationIconPairingWithTextContainerStyling}
`;
